import React from 'react'

import api from '@disco/api/server'

import LoginForm from 'components/common/login-form'
import { usePromiseAsString } from 'components/common/login-form/hooks'
import Separator from 'components/common/login-form/separator'
import { Box, Button, Flex, Heading, Text } from 'components/ds'

import type { AddToDiscoUser } from '../types'

type Props = {
  user: AddToDiscoUser
  showSignIn: boolean
  onShowSignIn: () => void
  onLoginUser: (...args: Array<any>) => any
  onForgotPassword: (email: string, returnUrl: string) => Promise<any>
  onGetSignUpUrl: () => Promise<string>
}

const AddToDiscoLoginForm = ({
  user,
  showSignIn,
  onShowSignIn,
  onLoginUser,
  onForgotPassword,
  onGetSignUpUrl,
}: Props): React.ReactNode => {
  const signupUrl = usePromiseAsString(onGetSignUpUrl)

  const handleSignUp = () => {
    const url = new URL(signupUrl ?? '')
    url.searchParams.set('utm_source', 'save_to_disco_modal_gateway')
    window.open(url.toString(), '_blank', 'noopener,noreferrer')
  }

  if (showSignIn) {
    return (
      <Box p="3">
        <LoginForm
          user={user}
          // @ts-expect-error - TODO: This should be updated to be a Path and not Location
          location={window.location}
          message="Sign in to add this music to your DISCO"
          onLoginUser={onLoginUser}
          onForgotPassword={onForgotPassword}
          onSamlDiscovery={async email =>
            api.samlLogin({
              username: email.trim(),
              redirect_uri: window.location.href,
            })
          }
          onGetSignupUrl={onGetSignUpUrl}
        />
      </Box>
    )
  }

  return (
    <Box p="3">
      <Flex
        direction="column"
        gap="3"
        width="100%"
        minWidth="230px"
        maxWidth="308px"
      >
        <Heading size="6" mt="0" mb="0">
          Save to DISCO
        </Heading>
        <Text size="2" color="gray">
          These tracks will be saved as a new playlist in your DISCO account.
        </Text>
        <Button
          size="3"
          color="gray"
          highContrast
          onClick={handleSignUp}
          disabled={!signupUrl}
        >
          Sign up to DISCO
        </Button>
        <Separator or />
        <Button size="3" variant="soft" color="gray" onClick={onShowSignIn}>
          Sign in
        </Button>
      </Flex>
    </Box>
  )
}

export default AddToDiscoLoginForm
